import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VMenu,
    {
      attrs: {
        "close-on-content-click": false,
        "nudge-width": 200,
        "offset-y": "",
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on, attrs }) {
            return [
              _c(
                VBtn,
                _vm._g(
                  _vm._b(
                    { attrs: { icon: "", small: "" } },
                    "v-btn",
                    attrs,
                    false
                  ),
                  on
                ),
                [_vm._m(0)],
                1
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.isCompetitorSelectionOpen,
        callback: function ($$v) {
          _vm.isCompetitorSelectionOpen = $$v
        },
        expression: "isCompetitorSelectionOpen",
      },
    },
    [
      _vm._v(" "),
      _c(
        VCard,
        { staticClass: "pa-2" },
        [
          _c(VAutocomplete, {
            attrs: {
              dense: "",
              multiple: "",
              "return-object": "",
              "hide-details": "",
              items: _vm.nonStoreGroupCompetitors,
              "item-disabled": _vm.isCompetitorDisabled,
              "item-text": "competitorDisplayDescription",
              "item-value": "_id",
            },
            on: { blur: _vm.onCompetitorsChange },
            model: {
              value: _vm.newSelectedCompetitors,
              callback: function ($$v) {
                _vm.newSelectedCompetitors = $$v
              },
              expression: "newSelectedCompetitors",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(VIcon, [_vm._v("filter_list")])
  },
]
render._withStripped = true

export { render, staticRenderFns }